import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const PeriodContent = ({data}) => {

    useEffect(() => {
        const period = ["MADRUGADA", "MANHÃ", "TARDE", "NOITE"];
        const periodMap = [];

        data.attendanceByPeriod?.forEach(item => {
            periodMap[item.period.toUpperCase()] = item.qty;
        });

        const values = [];
        const labels = [];

        period.forEach(period => {
            labels.push(ReportUtils.formatText(period));
            values.push(periodMap[period] || 0);
        });

        ReportUtils.createExportableTable(labels, values, "Atendimentos por período");
        GraphicUtils.barChart('attendance-by-period', values, labels, false);
    }, [data]);

    return (
        <>
            <div className="chart-report duo-bar-chart">
                <div className="chart-title text-center mb-3">Atendimentos por período</div>
                <div className="chart-report" id="attendance-by-period"></div>
            </div>
        </>
    );
};

export default PeriodContent;